/**
 * @fileoverview gRPC-Web generated client stub for contentstore
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: contentstore/contentstore.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var common_model_pb = require('../common/model_pb.js')

var contentstore_parts_pb = require('../contentstore/parts_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.contentstore = require('./contentstore_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contentstore.ContentStoreClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contentstore.ContentStorePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentID,
 *   !proto.contentstore.ByteArray>}
 */
const methodDescriptor_ContentStore_GetBytes = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetBytes',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentID,
  proto.contentstore.ByteArray,
  /**
   * @param {!proto.contentstore.ContentID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ByteArray.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ByteArray)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ByteArray>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getBytes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetBytes',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetBytes,
      callback);
};


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ByteArray>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getBytes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetBytes',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetBytes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentIDWithAccountID,
 *   !proto.contentstore.ByteArray>}
 */
const methodDescriptor_ContentStore_GetBytesInternal = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetBytesInternal',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentIDWithAccountID,
  proto.contentstore.ByteArray,
  /**
   * @param {!proto.contentstore.ContentIDWithAccountID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ByteArray.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentIDWithAccountID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ByteArray)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ByteArray>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getBytesInternal =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetBytesInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetBytesInternal,
      callback);
};


/**
 * @param {!proto.contentstore.ContentIDWithAccountID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ByteArray>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getBytesInternal =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetBytesInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetBytesInternal);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentID,
 *   !proto.contentstore.ByteArray>}
 */
const methodDescriptor_ContentStore_GetLinkedDocument = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetLinkedDocument',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentID,
  proto.contentstore.ByteArray,
  /**
   * @param {!proto.contentstore.ContentID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ByteArray.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ByteArray)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ByteArray>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getLinkedDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetLinkedDocument',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetLinkedDocument,
      callback);
};


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ByteArray>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getLinkedDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetLinkedDocument',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetLinkedDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentID,
 *   !proto.contentstore.URL>}
 */
const methodDescriptor_ContentStore_GetContentUrl = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetContentUrl',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentID,
  proto.contentstore.URL,
  /**
   * @param {!proto.contentstore.ContentID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.URL.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.URL)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.URL>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getContentUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetContentUrl',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetContentUrl,
      callback);
};


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.URL>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getContentUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetContentUrl',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetContentUrl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentID,
 *   !proto.contentstore.URL>}
 */
const methodDescriptor_ContentStore_GetDownloadURL = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetDownloadURL',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentID,
  proto.contentstore.URL,
  /**
   * @param {!proto.contentstore.ContentID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.URL.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.URL)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.URL>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getDownloadURL =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetDownloadURL',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetDownloadURL,
      callback);
};


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.URL>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getDownloadURL =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetDownloadURL',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetDownloadURL);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.GetSignedUrlWithKeyRequest,
 *   !proto.contentstore.GetSignedUrlWithKeyResponse>}
 */
const methodDescriptor_ContentStore_GetSignedUrlWithKey = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetSignedUrlWithKey',
  grpc.web.MethodType.UNARY,
  proto.contentstore.GetSignedUrlWithKeyRequest,
  proto.contentstore.GetSignedUrlWithKeyResponse,
  /**
   * @param {!proto.contentstore.GetSignedUrlWithKeyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.GetSignedUrlWithKeyResponse.deserializeBinary
);


/**
 * @param {!proto.contentstore.GetSignedUrlWithKeyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.GetSignedUrlWithKeyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.GetSignedUrlWithKeyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getSignedUrlWithKey =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetSignedUrlWithKey',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetSignedUrlWithKey,
      callback);
};


/**
 * @param {!proto.contentstore.GetSignedUrlWithKeyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.GetSignedUrlWithKeyResponse>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getSignedUrlWithKey =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetSignedUrlWithKey',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetSignedUrlWithKey);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentID,
 *   !proto.contentstore.ContentMetadata>}
 */
const methodDescriptor_ContentStore_GetMetadata = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetMetadata',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentID,
  proto.contentstore.ContentMetadata,
  /**
   * @param {!proto.contentstore.ContentID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ContentMetadata.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ContentMetadata)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ContentMetadata>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetMetadata',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetMetadata,
      callback);
};


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ContentMetadata>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetMetadata',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentIDWithAccountID,
 *   !proto.contentstore.ContentMetadata>}
 */
const methodDescriptor_ContentStore_GetMetadataInternal = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetMetadataInternal',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentIDWithAccountID,
  proto.contentstore.ContentMetadata,
  /**
   * @param {!proto.contentstore.ContentIDWithAccountID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ContentMetadata.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentIDWithAccountID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ContentMetadata)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ContentMetadata>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getMetadataInternal =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetMetadataInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetMetadataInternal,
      callback);
};


/**
 * @param {!proto.contentstore.ContentIDWithAccountID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ContentMetadata>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getMetadataInternal =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetMetadataInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetMetadataInternal);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentCreatedSince,
 *   !proto.contentstore.ContentMetadataList>}
 */
const methodDescriptor_ContentStore_GetMetadataCreatedSince = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetMetadataCreatedSince',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentCreatedSince,
  proto.contentstore.ContentMetadataList,
  /**
   * @param {!proto.contentstore.ContentCreatedSince} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ContentMetadataList.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentCreatedSince} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ContentMetadataList)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ContentMetadataList>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getMetadataCreatedSince =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetMetadataCreatedSince',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetMetadataCreatedSince,
      callback);
};


/**
 * @param {!proto.contentstore.ContentCreatedSince} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ContentMetadataList>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getMetadataCreatedSince =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetMetadataCreatedSince',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetMetadataCreatedSince);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.GetSqsQueueStatsRequest,
 *   !proto.contentstore.GetSqsQueueStatsResponse>}
 */
const methodDescriptor_ContentStore_GetSqsQueueStats = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetSqsQueueStats',
  grpc.web.MethodType.UNARY,
  proto.contentstore.GetSqsQueueStatsRequest,
  proto.contentstore.GetSqsQueueStatsResponse,
  /**
   * @param {!proto.contentstore.GetSqsQueueStatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.GetSqsQueueStatsResponse.deserializeBinary
);


/**
 * @param {!proto.contentstore.GetSqsQueueStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.GetSqsQueueStatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.GetSqsQueueStatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getSqsQueueStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetSqsQueueStats',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetSqsQueueStats,
      callback);
};


/**
 * @param {!proto.contentstore.GetSqsQueueStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.GetSqsQueueStatsResponse>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getSqsQueueStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetSqsQueueStats',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetSqsQueueStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.SetContentIgnoredRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ContentStore_SetContentIgnored = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/SetContentIgnored',
  grpc.web.MethodType.UNARY,
  proto.contentstore.SetContentIgnoredRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.contentstore.SetContentIgnoredRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.contentstore.SetContentIgnoredRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.setContentIgnored =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/SetContentIgnored',
      request,
      metadata || {},
      methodDescriptor_ContentStore_SetContentIgnored,
      callback);
};


/**
 * @param {!proto.contentstore.SetContentIgnoredRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.setContentIgnored =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/SetContentIgnored',
      request,
      metadata || {},
      methodDescriptor_ContentStore_SetContentIgnored);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.GetAllErroredContentRequest,
 *   !proto.contentstore.GetAllErroredContentResponse>}
 */
const methodDescriptor_ContentStore_GetAllErroredContent = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetAllErroredContent',
  grpc.web.MethodType.UNARY,
  proto.contentstore.GetAllErroredContentRequest,
  proto.contentstore.GetAllErroredContentResponse,
  /**
   * @param {!proto.contentstore.GetAllErroredContentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.GetAllErroredContentResponse.deserializeBinary
);


/**
 * @param {!proto.contentstore.GetAllErroredContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.GetAllErroredContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.GetAllErroredContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getAllErroredContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetAllErroredContent',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetAllErroredContent,
      callback);
};


/**
 * @param {!proto.contentstore.GetAllErroredContentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.GetAllErroredContentResponse>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getAllErroredContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetAllErroredContent',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetAllErroredContent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.GetInprogressContentByPurposeRequest,
 *   !proto.contentstore.GetInprogressContentByPurposeResponse>}
 */
const methodDescriptor_ContentStore_GetInprogressContentByPurpose = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetInprogressContentByPurpose',
  grpc.web.MethodType.UNARY,
  proto.contentstore.GetInprogressContentByPurposeRequest,
  proto.contentstore.GetInprogressContentByPurposeResponse,
  /**
   * @param {!proto.contentstore.GetInprogressContentByPurposeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.GetInprogressContentByPurposeResponse.deserializeBinary
);


/**
 * @param {!proto.contentstore.GetInprogressContentByPurposeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.GetInprogressContentByPurposeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.GetInprogressContentByPurposeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getInprogressContentByPurpose =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetInprogressContentByPurpose',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetInprogressContentByPurpose,
      callback);
};


/**
 * @param {!proto.contentstore.GetInprogressContentByPurposeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.GetInprogressContentByPurposeResponse>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getInprogressContentByPurpose =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetInprogressContentByPurpose',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetInprogressContentByPurpose);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ReindexContentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_ContentStore_ReindexContent = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/ReindexContent',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ReindexContentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.contentstore.ReindexContentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.contentstore.ReindexContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.reindexContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/ReindexContent',
      request,
      metadata || {},
      methodDescriptor_ContentStore_ReindexContent,
      callback);
};


/**
 * @param {!proto.contentstore.ReindexContentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.reindexContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/ReindexContent',
      request,
      metadata || {},
      methodDescriptor_ContentStore_ReindexContent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentID,
 *   !proto.contentstore.PartsManifest>}
 */
const methodDescriptor_ContentStore_ListParts = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/ListParts',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentID,
  contentstore_parts_pb.PartsManifest,
  /**
   * @param {!proto.contentstore.ContentID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  contentstore_parts_pb.PartsManifest.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.PartsManifest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.PartsManifest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.listParts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/ListParts',
      request,
      metadata || {},
      methodDescriptor_ContentStore_ListParts,
      callback);
};


/**
 * @param {!proto.contentstore.ContentID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.PartsManifest>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.listParts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/ListParts',
      request,
      metadata || {},
      methodDescriptor_ContentStore_ListParts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.GetPartBytesRequest,
 *   !proto.contentstore.ByteArray>}
 */
const methodDescriptor_ContentStore_GetPartBytes = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetPartBytes',
  grpc.web.MethodType.UNARY,
  proto.contentstore.GetPartBytesRequest,
  proto.contentstore.ByteArray,
  /**
   * @param {!proto.contentstore.GetPartBytesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ByteArray.deserializeBinary
);


/**
 * @param {!proto.contentstore.GetPartBytesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ByteArray)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ByteArray>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getPartBytes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetPartBytes',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetPartBytes,
      callback);
};


/**
 * @param {!proto.contentstore.GetPartBytesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ByteArray>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getPartBytes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetPartBytes',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetPartBytes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.ContentIDWithAccountID,
 *   !proto.contentstore.PartsManifest>}
 */
const methodDescriptor_ContentStore_ListPartsInternal = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/ListPartsInternal',
  grpc.web.MethodType.UNARY,
  proto.contentstore.ContentIDWithAccountID,
  contentstore_parts_pb.PartsManifest,
  /**
   * @param {!proto.contentstore.ContentIDWithAccountID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  contentstore_parts_pb.PartsManifest.deserializeBinary
);


/**
 * @param {!proto.contentstore.ContentIDWithAccountID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.PartsManifest)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.PartsManifest>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.listPartsInternal =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/ListPartsInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_ListPartsInternal,
      callback);
};


/**
 * @param {!proto.contentstore.ContentIDWithAccountID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.PartsManifest>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.listPartsInternal =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/ListPartsInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_ListPartsInternal);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.GetPartBytesInternalRequest,
 *   !proto.contentstore.ByteArray>}
 */
const methodDescriptor_ContentStore_GetPartBytesInternal = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetPartBytesInternal',
  grpc.web.MethodType.UNARY,
  proto.contentstore.GetPartBytesInternalRequest,
  proto.contentstore.ByteArray,
  /**
   * @param {!proto.contentstore.GetPartBytesInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.ByteArray.deserializeBinary
);


/**
 * @param {!proto.contentstore.GetPartBytesInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.ByteArray)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.ByteArray>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getPartBytesInternal =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetPartBytesInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetPartBytesInternal,
      callback);
};


/**
 * @param {!proto.contentstore.GetPartBytesInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.ByteArray>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getPartBytesInternal =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetPartBytesInternal',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetPartBytesInternal);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contentstore.GetContentIndexingStatusRequest,
 *   !proto.contentstore.GetContentIndexingStatusResponse>}
 */
const methodDescriptor_ContentStore_GetContentIndexingStatus = new grpc.web.MethodDescriptor(
  '/contentstore.ContentStore/GetContentIndexingStatus',
  grpc.web.MethodType.UNARY,
  proto.contentstore.GetContentIndexingStatusRequest,
  proto.contentstore.GetContentIndexingStatusResponse,
  /**
   * @param {!proto.contentstore.GetContentIndexingStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.contentstore.GetContentIndexingStatusResponse.deserializeBinary
);


/**
 * @param {!proto.contentstore.GetContentIndexingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.GetContentIndexingStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.GetContentIndexingStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contentstore.ContentStoreClient.prototype.getContentIndexingStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contentstore.ContentStore/GetContentIndexingStatus',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetContentIndexingStatus,
      callback);
};


/**
 * @param {!proto.contentstore.GetContentIndexingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.GetContentIndexingStatusResponse>}
 *     Promise that resolves to the response
 */
proto.contentstore.ContentStorePromiseClient.prototype.getContentIndexingStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contentstore.ContentStore/GetContentIndexingStatus',
      request,
      metadata || {},
      methodDescriptor_ContentStore_GetContentIndexingStatus);
};


module.exports = proto.contentstore;

